import useReveal from './useReveal';

export default function Mission() {
  const ref = useReveal();

  return (
    <div id="mission">
      <div className="mv-wrap reveal" ref={ref}>
        <div className="mv-block left">
          <div className="mv-tag">Our Mission</div>
          <h3>What Drives Us</h3>
          <p>
            To provide exceptional, reliable, and innovative services across all aspects of engineering
            and mining projects, and to achieve professional accreditation through a steadfast commitment
            to quality, innovation, and customer satisfaction.
          </p>
        </div>
        <div className="mv-block right">
          <div className="mv-tag">Our Vision</div>
          <h3>Where We're Headed</h3>
          <p>
            To expand our multidisciplinary capabilities and service offerings across the engineering,
            mining, and supply sectors, becoming the service provider of choice by consistently
            delivering excellence and efficiency from concept to completion.
          </p>
        </div>
      </div>
    </div>
  );
}
